import AgentPinManage from './auth/AgentPinManage';
import { AGENT_PIN_ENABLED } from './config/features';
import { isAgentUser } from './auth/loginDestination';
import TransferControlPage from './Pages/security/TransferControlPage';
import { MERCHANT_TRANSFER_CONTROL_ENABLED } from './config/features';
import './App.css';
import './Pages/css/main.css'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import axios from 'axios';

import Header from './Pages/nav/header';
import Footer from './Pages/nav/footer';
import Sidebar from './Pages/nav/sidebar';

import SetoffPaylist from './Pages/inactive/setoffPaylist';
import SetoffSettlements from './Pages/inactive/setoffSettlements';
import UnsoldMerchant from './Pages/inactive/unsoldMerchant';
import SettlementHis from './Pages/inactive/settlementHis';
import ExcelData from './Pages/inactive/excelData';
import Distributor from './Pages/inactive/distributor';
import Agency from './Pages/inactive/agency';
import Franchise from './Pages/inactive/franchise';
import Board from './Pages/inactive/board';
import Favorite from './Pages/inactive/favorite';
import SecurityCalendar from './Pages/inactive/securityCalendar';
import SettlementCalendar from './Pages/calendar';
import AgentDashboard from './Pages/agentDashboard';
import AgentWallet from './Pages/agentWallet';

import Login from './Pages/login';
import Dashboard from './Pages/dashboard';
import Paylist from './Pages/paylist';
import Settlements from './Pages/settlement/settlements';
import SettlementsAgent from './Pages/settlement/settlementsAgent';
import PayDetailList from './Pages/payDetailList';
import PayDetailListAgent from './Pages/payDetailListAgent';


import Submerchants from './Pages/submerchants';
import Admin from './Pages/admin';
import ProfitSettlement from './Pages/profitSettlement';
import MasterAccount from './Pages/masterAccount';
import AgentSettlement from './Pages/agentSettlement';
import Product from './Pages/product';
import Help from './Pages/help';
import SettlementAgentMobile from './Pages/settlement/settlementsAgentMobile';
import SettlementPending from './Pages/settlement/settlementPending';
import SettlementConfirm from './Pages/settlement/settlementConfirm';
import SettlementDeposits from './Pages/settlement/settlementDeposits';
import SettlementDepositStay from './Pages/settlement/settlementDepositStay';
import SettlementAgentDepositStay from './Pages/settlement/settlementAgentDepositStay';
import SettlementAgentDeposits from './Pages/settlement/settlementAgentDeposits';
import SettlementVoucher from './Pages/settlement/settlementVoucher';
import SettlementVoucherSub from './Pages/settlement/settlementVoucherSub';

import CreateMerchants from './Pages/createMerchants';
import CreateMerchantsAgent from './Pages/createMerchantsAgent';
import LockedAccounts from './Pages/lockedAccounts';

import FeeNotice from './Pages/feeNotice';
import MerchantTerminalFee from './Pages/merchantTerminalFee';
import WalletTransactionHistory from './Pages/walletTransactionHistory';
import WalletBalance from './Pages/walletBalance';
import PayoutAccountManage from './Pages/payoutAccountManage';
import DirectSettlement from './Pages/directSettlement';

import ErrorBoundary from './Pages/common/ErrorBoundary'
import { useDispatch, useSelector } from 'react-redux';
import IntegrateAgent from './Pages/integrateAgent';
import IntegrateAgentMobile from './Pages/integrateAgentMobile';
import IntegrateSettlement from './Pages/integrateSettlement';

import SugiManage from './Pages/sugi/sugiManage';
import SugiCancelManage from './Pages/sugi/sugiCancelManage';
import SugiListManage from './Pages/sugi/sugiListManage';
import SugiAgentListManage from './Pages/sugi/sugiAgentListManage';
import SugiHistoryManage from './Pages/sugi/sugiHistoryManage';

import RiskDashboard from './Pages/riskManagement/riskDashboard';
import RiskQuotaManage from './Pages/riskManagement/riskQuotaManage';
import RiskBlackListManage from './Pages/riskManagement/riskBlackListManage';
import RiskSubmerchants from './Pages/riskManagement/riskSubmerchants';
import RiskSetting from './Pages/riskManagement/riskSetting';
import RiskUnsoldMerchant from './Pages/riskManagement/riskUnsoldMerchant';
import RiskTrx from './Pages/riskManagement/riskTrx';
import RiskTrxV2 from './Pages/riskManagement/riskTrxV2';
import AdminOtpDevices from './Pages/adminOtpDevices';
import AuditLog from './Pages/auditLog';
import NotiBypassTargets from './Pages/notiBypassTargets';
import NotiBypassSendLogs from './Pages/notiBypassSendLogs';
import FastTerminalFeePreview from './Pages/dev/FastTerminalFeePreview';
import MerchantEditPreview from './Pages/dev/MerchantEditPreview';

// V2 Pages
import PaylistV2 from './Pages/v2/paylist';
import IntegrateAgentV2 from './Pages/v2/integrateAgent';

import { useEffect, useState } from 'react';
import { changeBrand, check_anthScreen } from './store';
import { getBrand } from './config/brand';
import { NOTI_BYPASS_ENABLED } from './config/features';
import AdminSessionGate from './auth/AdminSessionGate';
import SessionCheckError from './auth/SessionCheckError';
import { isAdminLoginPath, getAdminLoginDestination, canViewAgentDashboard, canViewAgentWallet } from './auth/loginDestination';

import { LoadingModal } from './Pages/component/modal/modal';
import useWindowSize from './Pages/hook/useWindowSize';

function AdminRoutes() {
    console.error = (message) => { };
    const { Rwidth, Rheight } = useWindowSize();

    const MyData = useSelector((state) => state.MyData);
    const anthScreen = useSelector((state) => state.anthScreen);
    const brand = useSelector((state) => state.brand);
    const canViewMerchantTerminalFee = MyData?.role === "SUPER" && (anthScreen.includes("단말기비 관리") || brand?.key === "fast");
    const canManageNotiBypassTargets =
        NOTI_BYPASS_ENABLED &&
        ["SUPER", "ADMIN"].includes(MyData?.role) &&
        anthScreen.includes("오앤유 관리");

    const location = useLocation();
    const dispatch = useDispatch();

    const [anthLoaded, setAnthLoaded] = useState(false);
    const [accessError, setAccessError] = useState(false);
    const [accessExpired, setAccessExpired] = useState(false);
    const [accessRetry, setAccessRetry] = useState(0);
    const isLoginRoute = isAdminLoginPath(location.pathname);
    const isV2Route = location.pathname.startsWith('/v2');
    const isFullViewportDevPage = location.pathname === '/dev/merchant-edit-preview';
    const v1AppStyle = isFullViewportDevPage ? { width: "100%", maxWidth: "none", margin: 0 } : { maxWidth: "1920px", margin: "0 auto" };

    useEffect(() => {
        dispatch(changeBrand(getBrand()));
        setAnthLoaded(false);
        setAccessError(false);
        setAccessExpired(false);
        if (isLoginRoute) return;
        const controller = new AbortController();
        let active = true;
        const loadAccess = async () => {
            try {
                const response = await axios.get(process.env.REACT_APP_API + "/api/admin/access/info", {
                    withCredentials: true,
                    signal: controller.signal,
                    timeout: 10000,
                });
                if (!active) return;
                const tmp = response?.data;
                if (tmp?.code < 2000) {
                    dispatch(check_anthScreen(tmp?.data?.screen ?? []));
                } else if (tmp?.code === 9999) {
                    dispatch(check_anthScreen([]));
                    setAccessExpired(true);
                    return;
                } else {
                    throw new Error('Unexpected access response');
                }
                setAnthLoaded(true);
            } catch (error) {
                if (active) setAccessError(true);
            }
        };
        loadAccess();
        return () => {
            active = false;
            controller.abort();
        };
    }, [MyData, isLoginRoute, dispatch, accessRetry]);

    if (isLoginRoute) {
        return (
            <div className="App" style={v1AppStyle}>
                <div className="py-0 md:py-0 header">
                    <div className="section1">
                        <div className="section2 main"><ErrorBoundary><Login /></ErrorBoundary></div>
                    </div>
                    <Footer />
                </div>
            </div>
        );
    }
    if (accessExpired) return <Navigate to="/" replace />;
    if (accessError) return <SessionCheckError onRetry={() => setAccessRetry(value => value + 1)} />;
    if (!anthLoaded) return <LoadingModal />;

    // V2 라우트는 별도로 처리 (기존 Header/Sidebar 없이)
    if (isV2Route) {
        return (
            <div className="App" style={{ width: '100%', height: '100vh', overflow: 'hidden', position: 'fixed', top: 0, left: 0 }}>
                <ErrorBoundary>
                    <Routes>
                        {anthScreen.includes("거래내역") && <Route path="/v2/paylist" element={<PaylistV2 />} />}
                        {anthScreen.includes("통합에이전트") && <Route path="/v2/integrateAgent" element={<IntegrateAgentV2 />} />}
                        <Route path="/v2/*" element={<div style={{ padding: '20px' }}>V2 페이지를 찾을 수 없습니다. 경로: {location.pathname}</div>} />
                    </Routes>
                </ErrorBoundary>
            </div>
        );
    }

    // 기존 V1 라우트
    return (
        <div className="App" style={v1AppStyle}>
            <div className="py-0 md:py-0 header">
                <Header />
                <div className="section1" >
                    <Sidebar />
                    <div className={`section2 ${location.pathname === "/" ? "main" : ""}`}>
                        <ErrorBoundary>
                                <Routes>
                                    {MyData?.role === "SUPER" ? (
                                        anthScreen.includes("대시보드") &&
                                        <Route
                                            path="/dashboard"
                                            element={<Dashboard />}
                                        />
                                    ) : ""}
                                    {anthScreen.includes("거래내역") && <Route path="/paylist" element={<Paylist />} />}
                                    {anthScreen.includes("정산달력") && <Route path="/integrateSettlement" element={<IntegrateSettlement />} />}


                                    {anthScreen.includes("가맹점 정산내역") && <Route path="/settlements" element={<Settlements />} />}
                                    {anthScreen.includes("에이전트 정산내역") && <Route path="/settlementsAgent" element={<SettlementsAgent />} />}
                                    {anthScreen.includes("수익 정산") && <Route path="/agentSettlement" element={<AgentSettlement />} />}
                                    {anthScreen.includes("에이전트 정산내역") && <Route path="/settlementsAgentMobile" element={<SettlementAgentMobile />} />}
                                    {canViewAgentDashboard(MyData, anthScreen) && <Route path="/agentDashboard" element={<AgentDashboard />} />}
                                    {AGENT_PIN_ENABLED && isAgentUser(MyData) && <Route path="/agentPin" element={<AgentPinManage />} />}
                                    {canViewAgentWallet(MyData, anthScreen) && <Route path="/agentWallet" element={<AgentWallet />} />}
                                    {anthScreen.includes("상세정보") && <Route path="/payDetailList" element={MyData?.role == "SUPER" || MyData?.role == "SM" ? <PayDetailList /> : <PayDetailListAgent />} />}
                                    {anthScreen.includes("상세정보") && <Route path="/settlementPending" element={<SettlementPending />} />}
                                    {anthScreen.includes("상세정보") && <Route path="/settlementConfirm" element={<SettlementConfirm />} />}
                                    {anthScreen.includes("상세정보") && <Route path="/settlementDeposits" element={<SettlementDeposits />} />}
                                    {anthScreen.includes("상세정보") && <Route path="/settlementDepositStay" element={<SettlementDepositStay />} />}
                                    {anthScreen.includes("상세정보") && <Route path="/settlementAgentDepositStay" element={<SettlementAgentDepositStay />} />}
                                    {anthScreen.includes("상세정보") && <Route path="/settlementAgentDeposits" element={<SettlementAgentDeposits />} />}
                                    {anthScreen.includes("상세정보") && <Route path="/settlementVoucher" element={<SettlementVoucher />} />}
                                    {anthScreen.includes("상세정보") && <Route path="/settlementVoucherSub" element={<SettlementVoucherSub />} />}


                                    {anthScreen.includes("가맹점") && <Route path="/submerchants" element={<Submerchants />} />}
                                    {anthScreen.includes("가맹점") && <Route path="/createMerchants" element={MyData?.role == "SUPER" ? <CreateMerchants /> : <CreateMerchantsAgent />} />}
                                    {MyData?.role === "SUPER" && <Route path="/lockedAccounts" element={<LockedAccounts />} />}


                                    {anthScreen.includes("통합에이전트") && <Route path="/integrateAgent" element={<IntegrateAgent />} />}
                                    {/* {anthScreen.includes("통합에이전트") && <Route path="/integrateAgent" element={MyData?.role == "SUPER" ? <IntegrateAgent /> : <IntegrateAgentMobile />} />} */}


                                    {anthScreen.includes("수기결제") && <Route path="/sugiManage" element={<SugiManage />} />}
                                    {/* {anthScreen.includes("수기결제취소") && <Route path="/sugiCancelManage" element={<SugiCancelManage />} />} */}
                                    {anthScreen.includes("수기결제승인내역") && <Route path="/sugiListManage" element={MyData?.role == "SUPER" ? <SugiListManage /> : <SugiAgentListManage />} />}

                                    {canViewMerchantTerminalFee && <Route path="/merchantTerminalFee" element={brand?.key === "fast" ? <FastTerminalFeePreview /> : <MerchantTerminalFee />} />}
                                    {MyData?.role === "SUPER" && <Route path="/dev/merchant-edit-preview" element={<MerchantEditPreview />} />}
                                    {MyData?.role === "SUPER" && anthScreen.includes("입출금내역") && <Route path="/walletTransactionHistory" element={<WalletTransactionHistory />} />}
                                    {MyData?.role === "SUPER" && MERCHANT_TRANSFER_CONTROL_ENABLED && <Route path="/walletTransferControl" element={<TransferControlPage />} />}
                                    {MyData?.role === "SUPER" && anthScreen.includes("지갑잔액현황") && <Route path="/walletBalance" element={<WalletBalance />} />}
                                    {MyData?.role === "SUPER" && (anthScreen.includes("지급계좌관리") || anthScreen.includes("지급계좌입출금")) && <Route path="/payoutAccountManage" element={<PayoutAccountManage />} />}
                                    <Route path="/payoutAccountHistory" element={<Navigate to="/payoutAccountManage" />} />
                                    {MyData?.role === "SUPER" && anthScreen.includes("직접정산") && <Route path="/directSettlement" element={<DirectSettlement />} />}

                                    {MyData?.role === "SUPER" && (
                                        <>
                                            {anthScreen.includes("할부관리") && <Route path="/riskQuotaManage" element={<RiskQuotaManage />} />}
                                            {anthScreen.includes("할부관리") && <Route path="/riskBlackListManage" element={<RiskBlackListManage />} />}
                                            {/* {anthScreen.includes("RM") && <Route path="/riskDashboard" element={<RiskDashboard />} />} */}
                                            {anthScreen.includes("RM") && <Route path="/riskTrx" element={<RiskTrx />} />}
                                            {anthScreen.includes("RM") && <Route path="/riskTrxV2" element={<RiskTrxV2 />} />}
                                            {/* {anthScreen.includes("할부관리") && <Route path="/riskSubmerchants" element={<RiskSubmerchants />} />} */}
                                            {anthScreen.includes("할부관리") && <Route path="/riskSetting" element={<RiskSetting />} />}
                                            {/* {anthScreen.includes("할부관리") && <Route path="/riskUnsoldMerchant" element={<RiskUnsoldMerchant />} />} */}

                                            {anthScreen.includes("수기결제처리내역") && <Route path="/sugiHistoryManage" element={<SugiHistoryManage />} />}
                                            {anthScreen.includes("관리자 조회") && <Route path="/admin" element={<Admin />} />}
                                            {anthScreen.includes("감사 로그") && <Route path="/auditLog" element={<AuditLog />} />}
                                            {anthScreen.includes("수익 정산") && <Route path="/profitSettlement" element={<ProfitSettlement />} />}
                                            {anthScreen.includes("위즈페이 계좌") && <Route path="/masterAccount" element={<MasterAccount />} />}
                                            {anthScreen.includes("단말기 관리") && <Route path="/product" element={<Product />} />}
                                            {anthScreen.includes("수수료안내") && <Route path="/feeNotice" element={<FeeNotice />} />}
                                            {anthScreen.includes("고객센터") && <Route path="/help" element={<Help />} />}
                                            <Route path="/adminOtpDevices" element={<AdminOtpDevices />} />
                                        </>
                                    )}
                                    {canManageNotiBypassTargets && <Route path="/notiBypassTargets" element={<NotiBypassTargets />} />}
                                    {canManageNotiBypassTargets && <Route path="/notiBypassSendLogs" element={<NotiBypassSendLogs />} />}

                                    {/* <Route path="/setoffPaylist" element={<SetoffPaylist />} />
                                    <Route path="/setoffSettlements" element={<SetoffSettlements />} />
                                    <Route path="/unsoldMerchant" element={<UnsoldMerchant />} />
                                    <Route path="/settlementHis" element={<SettlementHis />} />
                                    <Route path="/excelData" element={<ExcelData />} />
                                    <Route path="/distributor" element={<Distributor />} />
                                    <Route path="/agency" element={<Agency />} />
                                    <Route path="/franchise" element={<Franchise />} />
                                    <Route path="/securityCalendar" element={<SecurityCalendar />} />
                                    <Route path="/board" element={<Board />} />
                                    <Route path="/favorite" element={<Favorite />} /> */}

                                    <Route path="*" element={
                                        <Navigate to={
                                            getAdminLoginDestination(MyData)
                                        } />
                                    } />
                                </Routes>
                        </ErrorBoundary>
                    </div>
                </div>
                <Footer />
            </div>
        </div>
    );
}

function App() {
    return <AdminSessionGate><AdminRoutes /></AdminSessionGate>;
}

export default App;
